import { combineReducers } from 'redux';
import list from 'src/modules/workflowLaunch/list/workflowLaunchListReducers';

// import form slice
import destroy from 'src/modules/workflowLaunch/destroy/workflowLaunchDestroyReducers';
import form from 'src/modules/workflowLaunch/form/workflowLaunchFormReducers';
import importerReducer from 'src/modules/workflowLaunch/importer/workflowLaunchImporterReducers';
import view from 'src/modules/workflowLaunch/view/workflowLaunchViewReducers';

export default combineReducers({
  list,
  form,
  view,
  destroy,
  importer: importerReducer,
});
